import React from 'react'
import Svg from './Svg'
export const SvgChevronUp = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12.004 9.751l9.441 9.441L24 16.638 12.004 4.641 0 16.642l2.556 2.553z" />
  </Svg>
))
SvgChevronUp.isIcon = true
export default SvgChevronUp
